import { H2, Paragraph } from '@sbab-ui/components'
import OrangeArrow from '../../assets/OrangeArrow'
import Icon from '../../assets/person-speaking.svg'

function EnergyConsultingBanner() {
  return (
    <div className="mt-10 bg-surface-banana px-3 py-6 text-lg">
      <div className="flex flex-col items-center lg:flex-row lg:justify-between">
        <div className="mb-4 flex justify-center lg:hidden">
          <img src={Icon} alt="ikon pratande person" className="size-44" />
        </div>

        <div className="lg:mx-3 lg:w-2/3">
          <H2 className=" text-24 md:text-32 !mb-4">
            Fri energirådgivning för dig som är bolånekund
          </H2>
          <Paragraph>
            Är du osäker på vilken energirenovering som passar ditt hus? Du som är bolånekund hos
            oss får kostnadsfri rådgivning med Anticimex.{' '}
            <a
              href="https://www.anticimex.se/formular/skriv-till-oss-energiradgivning/?utm_source=sbab.se&utm_medium=referral&utm_campaign=sbab_energi_25"
              className="mt-5 flex space-x-2 font-medium lg:mt-6"
              aria-label="Länk till Anticimex"
            >
              <span className="!text-base">Boka tid med energiexpert hos Anticimex</span>
              <OrangeArrow className="!mt-0.5 size-5" aria-label="Knapp till Anticimex" />
            </a>
          </Paragraph>
        </div>

        <div className="hidden justify-end lg:block">
          <img src={Icon} alt="ikon pratande person" className="size-44" />
        </div>
      </div>
    </div>
  )
}

export default EnergyConsultingBanner
